/**
 * Assets Manifest
 * Central reference for all project assets
 * Usage: import { logos, nfts, branding } from '@/assets'
 */

// Pythentity Logos
export const logos = {
  v01: {
    black: '/assets/Logo_V01_Black.png',
    white: '/assets/Logo_V01_White.png',
    default: '/assets/Logo_V01_Prancheta 1.png',
  },
  v02: {
    color: '/assets/Logo_V02.png',
    black: '/assets/Logo_V02_Preto.png',
    white: '/assets/Logo_V02_White.png',
  },
  vector: {
    eps1: '/assets/LOGO EPS.eps',
    eps2: '/assets/LOGO EPS2.eps',
  }
}

// Pythenian NFT Avatars
export const nfts = {
  derrp: '/assets/derrp.png',
  hennessy: '/assets/hennessy.png',
  jowe: '/assets/Jowe.png',
  frozen: '/assets/frozen.png',
  mojo: '/assets/mojo.png',
  planck: '/assets/Planck.png',
  pythia: '/assets/Pythia.png',
  default: '/assets/Default.jpg',

  // Array for random selection
  all: [
    '/assets/derrp.png',
    '/assets/hennessy.png',
    '/assets/Jowe.png',
    '/assets/frozen.png',
    '/assets/mojo.png',
    '/assets/Planck.png',
    '/assets/Pythia.png',
  ],

  // Get random NFT avatar
  random: () => {
    const randomIndex = Math.floor(Math.random() * nfts.all.length)
    return nfts.all[randomIndex]
  }
}

// Pyth Official Branding
export const branding = {
  fullLogo: {
    dark: {
      svg: '/assets/Pyth Full Logo/Dark/pyth-logo-dark.svg',
      png: '/assets/Pyth Full Logo/Dark/pyth-logo-dark.png',
    },
    light: {
      svg: '/assets/Pyth Full Logo/Light/pyth-logo-light.svg',
      png: '/assets/Pyth Full Logo/Light/pyth-logo-light.png',
    }
  },
  symbol: {
    dark: {
      svg: '/assets/Pyth Symbol/Dark/pyth-logo-symbol-dark.svg',
      png: '/assets/Pyth Symbol/Dark/pyth-logo-symbol-dark.png',
    },
    light: {
      svg: '/assets/Pyth Symbol/Light/pyth-logo-symbol-light.svg',
      png: '/assets/Pyth Symbol/Light/pyth-logo-symbol-light.png',
    }
  },
  wordmark: {
    dark: {
      svg: '/assets/Pyth Wordmark/Dark/pyth-logo-wordmark-dark.svg',
      png: '/assets/Pyth Wordmark/Dark/pyth-logo-wordmark-dark.png',
    },
    light: {
      svg: '/assets/Pyth Wordmark/Light/pyth-logo-wordmark-light.svg',
      png: '/assets/Pyth Wordmark/Light/pyth-logo-wordmark-light.png',
    }
  },
  token: {
    svg: '/assets/Pyth Token Logo/pyth-token.svg',
    png: '/assets/Pyth Token Logo/pyth-token.png',
  }
}

// Decorative Art
export const art = {
  art01: '/assets/Art01.png',
  art02: '/assets/Art02.png',
  art03: '/assets/Art03.png',
  art04: '/assets/Art04.png',
  all: [
    '/assets/Art01.png',
    '/assets/Art02.png',
    '/assets/Art03.png',
    '/assets/Art04.png',
  ],
  random: () => {
    const randomIndex = Math.floor(Math.random() * art.all.length)
    return art.all[randomIndex]
  }
}

// Color Palette (reference images)
export const colorPalette = {
  fullPalette: '/assets/Pyth Branding Color Palette More/Pyth Full Color palette.jpg',
  // Individual color swatches
  swatches: [
    '/assets/Pyth Branding Color Palette More/01.png',
    '/assets/Pyth Branding Color Palette More/02.png',
    '/assets/Pyth Branding Color Palette More/3.png',
    '/assets/Pyth Branding Color Palette More/4.png',
    '/assets/Pyth Branding Color Palette More/26.png',
    '/assets/Pyth Branding Color Palette More/31.png',
    '/assets/Pyth Branding Color Palette More/34.png',
    '/assets/Pyth Branding Color Palette More/39.png',
    '/assets/Pyth Branding Color Palette More/51.png',
    '/assets/Pyth Branding Color Palette More/52.png',
    '/assets/Pyth Branding Color Palette More/53.png',
    '/assets/Pyth Branding Color Palette More/54.png',
    '/assets/Pyth Branding Color Palette More/55.png',
    '/assets/Pyth Branding Color Palette More/57.png',
    '/assets/Pyth Branding Color Palette More/58.png',
    '/assets/Pyth Branding Color Palette More/59.png',
  ]
}

// Export all as default for convenience
export default {
  logos,
  nfts,
  branding,
  art,
  colorPalette
}
